import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, createVNode as _createVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "spinner"
}
const _hoisted_2 = {
  key: 1,
  class: "card reports-lot-status"
}
const _hoisted_3 = {
  key: 0,
  class: "reports-container"
}
const _hoisted_4 = { class: "table-total" }
const _hoisted_5 = { class: "label-text-total" }
const _hoisted_6 = { class: "reports-container-bar-chart" }
const _hoisted_7 = { class: "report-chart" }
const _hoisted_8 = { class: "report-lots-color" }
const _hoisted_9 = { class: "label-text-lots-background" }
const _hoisted_10 = { class: "reports-container-table" }
const _hoisted_11 = { class: "report-table" }
const _hoisted_12 = { class: "td-spacing" }
const _hoisted_13 = {
  key: 1,
  class: "report-no-data"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return ($setup.loading)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1))
    : (_openBlock(), _createElementBlock("div", _hoisted_2, [
        _cache[3] || (_cache[3] = _createElementVNode("div", { class: "table-title" }, [
          _createElementVNode("h2", { class: "title-main" }, "Status Report")
        ], -1)),
        ($setup.statusByEstate.length > 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.statusByEstate, (estateData, estateIndex) => {
                return (_openBlock(), _createElementBlock(_Fragment, { key: estateIndex }, [
                  _createElementVNode("div", _hoisted_4, [
                    _createElementVNode("span", _hoisted_5, _toDisplayString(estateData.estate), 1)
                  ]),
                  _createElementVNode("div", _hoisted_6, [
                    _createElementVNode("div", _hoisted_7, [
                      _createElementVNode("div", _hoisted_8, [
                        (_openBlock(), _createElementBlock(_Fragment, null, _renderList($setup.lotStatusOptions, (lotStatus, index) => {
                          return _createElementVNode("div", {
                            class: "lots-container-color",
                            key: index
                          }, [
                            _createElementVNode("div", {
                              class: "background-color",
                              style: _normalizeStyle({ backgroundColor: $setup.backgroundColorForLots[index] })
                            }, null, 4),
                            _createElementVNode("span", _hoisted_9, _toDisplayString(lotStatus), 1)
                          ])
                        }), 64))
                      ]),
                      _createVNode($setup["ChartForReports"], {
                        labels: $setup.lotStatusOptions,
                        setData: estateData.count,
                        backgroundColor: $setup.chartBackgroundColorForLots,
                        title: 'Lots Status',
                        chartType: $setup.ChartsTypes.BAR,
                        options: $setup.optionsBarChartForWebsiteAnalytics
                      }, null, 8, ["setData", "backgroundColor", "chartType", "options"])
                    ]),
                    _createElementVNode("div", _hoisted_10, [
                      _createElementVNode("div", _hoisted_11, [
                        _createElementVNode("table", null, [
                          _cache[1] || (_cache[1] = _createElementVNode("thead", null, [
                            _createElementVNode("tr", null, [
                              _createElementVNode("th", null, "Status"),
                              _createElementVNode("th", null, "Total")
                            ])
                          ], -1)),
                          _createElementVNode("tbody", null, [
                            (_openBlock(), _createElementBlock(_Fragment, null, _renderList($setup.lotStatusOptions, (status, index) => {
                              return _createElementVNode("tr", { key: index }, [
                                _createElementVNode("td", null, _toDisplayString(status), 1),
                                _createElementVNode("td", null, _toDisplayString(estateData.count[index]), 1)
                              ])
                            }), 64))
                          ]),
                          _createElementVNode("tfoot", null, [
                            _createElementVNode("tr", null, [
                              _cache[0] || (_cache[0] = _createElementVNode("th", { class: "td-spacing" }, null, -1)),
                              _createElementVNode("td", _hoisted_12, _toDisplayString(estateData.total), 1)
                            ])
                          ])
                        ])
                      ])
                    ])
                  ])
                ], 64))
              }), 128))
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_13, [...(_cache[2] || (_cache[2] = [
              _createElementVNode("h2", { class: "subtitle-main" }, "No data to display", -1)
            ]))]))
      ]))
}